import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CacheBreakerInterceptor } from './cache-breaker.interceptor';
import { DeviceTypeInterceptor } from './device-type.interceptor';
import { ErrorNormalizerInterceptor } from './error-normalizer.interceptor';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: CacheBreakerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: ErrorNormalizerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: DeviceTypeInterceptor,
      multi: true,
    },
  ],
})
export class InterceptorsModule {}
